import { useQuery } from '@tanstack/react-query';

import { getUsers } from '../api';
import { usersQueryKeys } from '../data';
import { useUsersFilter, useUsersPagination } from '../store';

export const useGetUsers = () => {
  const filters = useUsersFilter();
  const pagination = useUsersPagination();

  const usersQuery = useQuery({
    queryKey: [
      ...usersQueryKeys.getUsers,
      {
        ...filters,
        ...pagination,
      },
    ],
    queryFn: getUsers.bind(null, { ...filters, ...pagination }),
    staleTime: 5_000,
  });

  return usersQuery;
};
